/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Mx_SsoInputs */

const en_mk_mx_sso = /** @type {(inputs: Mk_Mx_SsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSO / SAML`)
};

const id_mk_mx_sso = /** @type {(inputs: Mk_Mx_SsoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`SSO / SAML`)
};

/**
* | output |
* | --- |
* | "SSO / SAML" |
*
* @param {Mk_Mx_SsoInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_mx_sso = /** @type {((inputs?: Mk_Mx_SsoInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Mx_SsoInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_mx_sso(inputs)
	return en_mk_mx_sso(inputs)
});